// Swiss formatting helpers — apostrophe thousands separator (1'000'000)

export function formatNumber(value, decimals = 0) {
  if (value === null || value === undefined || value === '' || isNaN(value)) return '';
  return Number(value).toLocaleString('de-CH', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}

export function formatCHF(value, decimals = 0) {
  const n = formatNumber(value, decimals);
  return n === '' ? '' : `${n} CHF`;
}

/**
 * Montant selon l'unité d'affichage : 'chf' (brut) ou 'kchf' (÷1000, entier).
 * Source unique pour les bascules CHF/kCHF des hubs. Le séparateur de milliers
 * reste l'apostrophe suisse.
 */
export function formatMoney(value, unit = 'chf', decimals = 0) {
  if (value === null || value === undefined || value === '' || isNaN(value)) return '';
  return unit === 'kchf'
    ? formatNumber(Number(value) / 1000, decimals)
    : formatNumber(Number(value), decimals);
}

export function formatPercent(value, decimals = 1) {
  if (value === null || value === undefined || value === '' || isNaN(value)) return '';
  return `${Number(value).toLocaleString('de-CH', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })} %`;
}

/**
 * Swiss date display : dd-mm-yyyy (with dashes, per Palestre convention).
 * Accepts ISO strings (yyyy-mm-dd), Date objects, or anything Date can parse.
 * Returns '' if value is empty or unparseable.
 *
 * Project-wide rule : always display dates in this format. Inputs (form fields,
 * APIs) keep ISO yyyy-mm-dd under the hood — only the display layer reformats.
 */
export function formatDate(value) {
  if (!value) return '';
  // Fast path for ISO yyyy-mm-dd (avoids timezone shifts from Date parsing).
  if (typeof value === 'string') {
    const m = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (m) return `${m[3]}-${m[2]}-${m[1]}`;
  }
  const d = value instanceof Date ? value : new Date(value);
  if (isNaN(d.getTime())) return '';
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  return `${dd}-${mm}-${d.getFullYear()}`;
}
